<template>
    <v-tabs 
        class="round-card"
        height="34"
        background-color="background-1"
        slider-color="primary">
        <v-tab key="Campi" ripple class="secondary-tab">
            Campi
        </v-tab>
        <v-tab key="Azioni" ripple class="secondary-tab">
            Azioni
        </v-tab>
        <v-tab key="Categorie" ripple class="secondary-tab">
            Categorie
        </v-tab>

        <v-tab-item class="background-1 pt-3 pb-offset pb-offset" key="Campi">
            <v-row class="ma-0">
                
                <v-col class="pa-0 pt-2" cols="12">
                    <fields-selector model-def="credential"></fields-selector>
                </v-col>

            </v-row>
        </v-tab-item>
        
        <v-tab-item class="background-1 pt-3 pb-offset pb-offset" key="Azioni">
            <v-row class="ma-0">
                
                <v-col class="pa-0 pt-2" cols="12">
                    <actions-selector model-def="credential"></actions-selector>
                </v-col>

            </v-row>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-offset pb-offset" key="Categorie">
            <v-row class="ma-0">
                <v-col class="pa-0" cols="12" v-if="$store.getters.checkModelPermissions('credential')">
                    <crud
                        title='Tipo Credenziale'
                        action-icon='settings'
                        model-def='generaltypes-credential_type'
                        action-position='absolute'
                        crudDialog
                    ></crud>
                </v-col>
            </v-row>
        </v-tab-item>
    </v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import AssetsOptions from '@/components/modules/assets/settings/AssetsOptions'

	export default {
		name:'assets-settings',
        components: {
            AssetsOptions,
			FieldsSelector,
			ActionsSelector,
        },		
		data() {
			return {

			}
		},
	}
  </script>
